// Footer.js - New file for reusable footer component
import React from 'react';

const Footer = () => {
  return (
    <footer 
      style={{
       background:'white',
        padding: '12px 24px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '13px',
        color: '#ff6b35',
        borderTop: '1px solid #e2e8f0',
        position: 'fixed',
        bottom: 0,
        left:'280px',
        right: 0,
        fontWeight:'bold',
        // zIndex: 1000
        gap:'10px'
      }}
    >
      <div>© 2026 Critical River. All Rights Reserved.</div>
      <div>Version 1.0.0</div>
    </footer>
  );
};

export default Footer;